import React from "react"
import classNames from "classnames"
import styles from "./DynamicButton.module.scss"

const DynamicButton = ({ theme = "blue", outline = false, children, onClick, className }) => {
  const buttonClass = classNames(styles["primary-button"], {
    [styles[theme]]: !outline,
    [styles[`${theme}-outline`]]: outline,
  }, className)

  return (
    <button className={buttonClass} onClick={onClick}>
      {children}
    </button>
  )
}

export default DynamicButton
